<template>
    <span v-html="svg"></span>
</template>
<script>
    import { cdnUrl } from '../../config';

    export default {
        name: 'ihsvg',
        data: function() {
            return {
                svg: ''
            }
        },
        props: ['src'],
        mounted() {
            const url = cdnUrl + this.src;
            this.$http.get(url)
                .then((response) => this.svg = response.data)
        },
        computed: {
            url() {
                return url = cdnUrl + this.src;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// Ihsvg.vue?5bf1d136